console.time('novada')

console.debug('Novada Start')

import 'boxicons'
import './jquery-compat'
import './cta-delay'
import './main_menu'
import './testimonials'
import './woocommerce-payment-methods'
import './modal'
import './cart'
import './force-reload-payment'

console.timeEnd('novada')
